import { Profile } from 'app/redux/Profile/model'
import * as utils from 'app/utils'
import * as _ from 'lodash'
import * as moment from 'moment'
import { ServiceError, WebServiceBase, WebServiceResponse } from '../WebServiceBase';

const p = {
  createdWhen: moment().toISOString(),
  lastLoginWhen: moment().toISOString()
}

// supply some error messages for our domains
ServiceError.domainCatalogs.FamilyInfo = {
  100: 'Profile already exists'
}

export class FamilyInfoResponse extends WebServiceResponse {
  public static fromJSON(raw: any): FamilyInfoResponse {
    const r = new FamilyInfoResponse();
    r.deserialize(raw);
    return r;
  }

  info: Profile;

  deserialize(raw: any): FamilyInfoResponse {
    super.deserialize(raw);
    // tslint:disable-next-line:no-console
    //console.log('profile raw looks like: ' + JSON.stringify(p, undefined, 4))
    //raw.info = p;
    if (raw.info) { this.info = Profile.fromJSON(raw.info) }
    return this
  }
}

// tslint:disable-next-line:max-classes-per-file
export class FamilyInfoService extends WebServiceBase {
  protected serviceEndpoint: string;
  protected apiEndpoint: string;

  constructor(serviceEndpoint: string) {
    super()
    //if (!serviceEndpoint) { serviceEndpoint = 'http://192.168.2.92/retirementAppServer/'; }
    //if (!serviceEndpoint) { serviceEndpoint = 'http://agave.thosdavidson.com:8001/retirementAppServer/' }
    this.serviceEndpoint = serviceEndpoint;
    this.apiEndpoint = this.serviceEndpoint + 'api/familyInfo/';
  }

  public getFamilyInfo(token: string): Promise<FamilyInfoResponse> {
    const uri = this.apiEndpoint + 'get';
    const req = this.requestOptions(uri, undefined, token, { method: 'GET' })
    return utils.xfetch(req)
      .then((response) => response.json())
      .then(FamilyInfoResponse.fromJSON)
      .then((fr: FamilyInfoResponse) => {
        if (fr.IsError) { throw fr }
        // tslint:disable-next-line:no-console
        //console.log('getFamilyInfo worked. ' + JSON.stringify(fr));
        return fr;
      })
      .catch((reason) => {
        // tslint:disable-next-line:no-console
        console.log('getFamilyInfo failed. ' + JSON.stringify(reason));
        throw reason;
      });
  }

  public storeFamilyInfo(accessToken: string, profile: Profile, firstTime: boolean = false): Promise<FamilyInfoResponse> {
    const method = firstTime ? 'Put' : 'Post'
    const uri = this.apiEndpoint + method;
    const req = this.requestOptions(uri, { profile }, accessToken, { method })
    // tslint:disable:no-console
    //console.log('storeFamilyInfo begins... ' + JSON.stringify(profile));
    //console.log(accessToken);
    //console.log(uri);
    return utils.xfetch(req)
      .then((response) => response.json())
      .then(FamilyInfoResponse.fromJSON)
      .then((fr: FamilyInfoResponse) => {
        if (fr.IsError) { throw fr; }
        // tslint:disable-next-line:no-console
        //console.log('storeFamilyInfo worked. ' + JSON.stringify(fr));
        return fr;
      })
      .catch((reason) => {
        // tslint:disable-next-line:no-console
        console.log('storeFamilyInfo failed. ' + JSON.stringify(reason));
        throw reason;
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/services/FamilyInfoService/index.ts